import axios from "axios";
import { getCookie, removeCookie } from "../util/Cookie";
import { TokenName } from "../util/Common";

export const API_URL = "https://ai.xrai-api.com";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 응답 인터셉터

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);
    if (error.response) {
      console.log("Status:", error.response.status);
      console.log("Data:", error.response.data);
      if (error.response.status === 400) {
        return error;
      }
      if (error.response.status === 500) {
        return error;
      }

      if (error.response.status === 401) {
        removeCookie(TokenName);
        window.location.href = "/login";
      } else if (error.response.status === 403) {
        removeCookie(TokenName);
        window.location.href = "/login";
      }
    } else if (error.request) {
      console.error("No response received");
    }
    if (error.config?.headers?.errorpage) {
    }
  }
);

api.interceptors.request.use(
  (config) => {
    const token = getCookie(TokenName);

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default api;
